export interface TransactionType {
  id: number
  name: TransactionTypeEnum
  type: TransactionTypeKey
  code: string
}

export enum TransactionTypeEnum {
  CASH_TRANSFER = 'Cash Transfer',
  COUPON = 'Coupon',
  MANAGEMENT_FEE = 'Management Fee',
  CUSTODY_FEE = 'Custody Fee',
  MMF_PAYMENT = 'Money Market Funds',
  PAYDOWN = 'Principal Paydown',
  EQUITY_DIVIDEND = 'Equity Dividend',
  SECURITIES_LENDING_INCOME = 'Sec Lending Income',
  OVERDRAFT_CHARGE = 'Overdraft Charge',
  BUY = 'Buy',
  SELL = 'Sell',
  MATURITY = 'Maturity',
  REDEMPTION = 'Redemption',
  TRANSFER_IN = 'Transfer In',
  TRANSFER_OUT = 'Transfer Out',
  CALL_REDEMPTION = 'Call Redemption',
  PUT_REDEMPTION = 'Put Redemption',
  OTHER_INCOME = 'Other Income',
  FX_TRADE = 'Foreign Exchange Trade',
  OTHER_EXPENSE = 'Other Expense',
  FX_SPOT_TRADE = 'Spot FX Trade',
  FX_FORWARD_TRADE = 'Forward FX Trade',
  WRITE_DOWN = 'Writedown',
  CORPORATE_ACTION = 'Corporate Actions',
  EXCHANGE_IN = 'Exchange In',
  EXCHANGE_OUT = 'Exchange Out',
  CORPORATE_ACTION_SELL = 'Corporate Action Sell',
  INITIAL_LOAD = 'Initial Load',
  CAPITALIZATION_OF_INTEREST = 'Capitalization of Interest',
  EXPIRATION = 'Expiration',
  OPTION_SETTLE = 'Option Settle',
  OPTION_WRITE = 'Option Write',
  BUY_COVER = 'Buy Cover',
  SHORT_SELL = 'Short Sell',
  MARGIN_VARIATION_IN = 'Margin Variation In',
  MARGIN_VARIATION_OUT = 'Margin Variation Out',
  FUTURE_SETTLE = 'Future Settle',
  RETURN_OF_CAPITAL = 'Return of Capital',
  CAPITAL_GAIN_DISTRIBUTION = 'Capital Gain Distribution',
  CAPITAL_CONTRIBUTION = 'Capital Contribution',
  FOREIGN_TAX_WITHHELD = 'Foreign Tax Withheld',
  INITIAL_LOAD_OF_DEFERRED = 'Initial Load of Deferred',
  CONTRIBUTION_WITHDRAWAL = 'Cash Contribution / Withdrawal',
  CASH_FROM_CORPORATE_ACTION = 'Cash from Corporate Action',
  CASH_RECEIVABLE_ON_LOAD = 'Cash Receivable on Load',
  DIRECT_CASH_TRANSFER = 'Wire Transfer',
  STOCK_SPLIT = 'Stock Split',
  CURRENCY_FORWARD = 'Currency Forward',
  PRINCIPAL_REPAYMENT = 'Principal Repayment',
  OPTION_EXERCISE = 'Option Exercise',
  PREPAYMENT_ACCELERATION_PREMIUM = 'Prepayment / Acceleration Premium',
  MUTUAL_FUND_DIVIDEND = 'Mutual Fund Dividend',
  FOREIGN_TAX_WITHHELD_REPAYMENT = 'Foreign Tax Withheld Repayment',
  DRAW = 'Draw',
  PAYUP = 'Principal Payup',
  CASH_BALANCE_FIELD_ADJUSTMENT = 'Cash Balance Field Adjustment',
  UNSUPPORTED = 'UNSUPPORTED',
}

export type TransactionTypeKey = keyof typeof TransactionTypeEnum

export const types = Object.keys(TransactionTypeEnum) as TransactionTypeKey[]

export const CASH_ENTRIES = [
  TransactionTypeEnum.CASH_TRANSFER,
  TransactionTypeEnum.COUPON,
  TransactionTypeEnum.CUSTODY_FEE,
  TransactionTypeEnum.EQUITY_DIVIDEND,
  TransactionTypeEnum.MANAGEMENT_FEE,
  TransactionTypeEnum.MMF_PAYMENT,
  TransactionTypeEnum.OTHER_EXPENSE,
  TransactionTypeEnum.OTHER_INCOME,
  TransactionTypeEnum.OVERDRAFT_CHARGE,
  TransactionTypeEnum.PAYDOWN,
  TransactionTypeEnum.SECURITIES_LENDING_INCOME,
  TransactionTypeEnum.CAPITALIZATION_OF_INTEREST,
  TransactionTypeEnum.MARGIN_VARIATION_IN,
  TransactionTypeEnum.MARGIN_VARIATION_OUT,
  TransactionTypeEnum.RETURN_OF_CAPITAL,
  TransactionTypeEnum.CAPITAL_GAIN_DISTRIBUTION,
  TransactionTypeEnum.CAPITAL_CONTRIBUTION,
  TransactionTypeEnum.FOREIGN_TAX_WITHHELD,
  TransactionTypeEnum.FOREIGN_TAX_WITHHELD_REPAYMENT,
  TransactionTypeEnum.CONTRIBUTION_WITHDRAWAL,
  TransactionTypeEnum.CORPORATE_ACTION,
  TransactionTypeEnum.CASH_RECEIVABLE_ON_LOAD,
  TransactionTypeEnum.PREPAYMENT_ACCELERATION_PREMIUM,
  TransactionTypeEnum.MUTUAL_FUND_DIVIDEND,
  TransactionTypeEnum.PAYUP,
  TransactionTypeEnum.CASH_BALANCE_FIELD_ADJUSTMENT,
]

export const TRADE_ENTRIES = [
  TransactionTypeEnum.BUY,
  TransactionTypeEnum.CALL_REDEMPTION,
  TransactionTypeEnum.CORPORATE_ACTION_SELL,
  TransactionTypeEnum.MATURITY,
  TransactionTypeEnum.PUT_REDEMPTION,
  TransactionTypeEnum.REDEMPTION,
  TransactionTypeEnum.SELL,
  TransactionTypeEnum.OPTION_SETTLE,
  TransactionTypeEnum.FUTURE_SETTLE,
  TransactionTypeEnum.OPTION_WRITE,
  TransactionTypeEnum.SHORT_SELL,
  TransactionTypeEnum.EXPIRATION,
  TransactionTypeEnum.BUY_COVER,
  TransactionTypeEnum.PRINCIPAL_REPAYMENT,
  TransactionTypeEnum.OPTION_EXERCISE,
  TransactionTypeEnum.DRAW,
]

export const FX_ENTRIES = [
  TransactionTypeEnum.FX_SPOT_TRADE,
  TransactionTypeEnum.FX_FORWARD_TRADE,
]

export const DIRECT_TRANSFER = [TransactionTypeEnum.DIRECT_CASH_TRANSFER]

export const TRANSFERS = [
  TransactionTypeEnum.TRANSFER_OUT,
  TransactionTypeEnum.TRANSFER_IN,
  TransactionTypeEnum.EXCHANGE_IN,
  TransactionTypeEnum.EXCHANGE_OUT,
  TransactionTypeEnum.INITIAL_LOAD,
]

export const transactionTypesVal: TransactionType[] = [
  {
    id: 1,
    name: TransactionTypeEnum.CASH_TRANSFER,
    type: 'CASH_TRANSFER',
    code: 'TRN',
  },
  {
    id: 3,
    name: TransactionTypeEnum.COUPON,
    type: 'COUPON',
    code: 'CPN',
  },
  {
    id: 5,
    name: TransactionTypeEnum.MANAGEMENT_FEE,
    type: 'MANAGEMENT_FEE',
    code: 'MEXP',
  },
  {
    id: 6,
    name: TransactionTypeEnum.CUSTODY_FEE,
    type: 'CUSTODY_FEE',
    code: 'CEXP',
  },
  {
    id: 7,
    name: TransactionTypeEnum.MMF_PAYMENT,
    type: 'MMF_PAYMENT',
    code: 'MMF',
  },
  {
    id: 8,
    name: TransactionTypeEnum.PAYDOWN,
    type: 'PAYDOWN',
    code: 'PPD',
  },
  {
    id: 9,
    name: TransactionTypeEnum.EQUITY_DIVIDEND,
    type: 'EQUITY_DIVIDEND',
    code: 'DVD',
  },
  {
    id: 10,
    name: TransactionTypeEnum.SECURITIES_LENDING_INCOME,
    type: 'SECURITIES_LENDING_INCOME',
    code: 'SLI',
  },
  {
    id: 11,
    name: TransactionTypeEnum.OVERDRAFT_CHARGE,
    type: 'OVERDRAFT_CHARGE',
    code: 'OCH',
  },
  {
    id: 12,
    name: TransactionTypeEnum.BUY,
    type: 'BUY',
    code: 'BUY',
  },
  {
    id: 13,
    name: TransactionTypeEnum.SELL,

    type: 'SELL',
    code: 'SELL',
  },
  {
    id: 14,
    name: TransactionTypeEnum.MATURITY,
    type: 'MATURITY',
    code: 'MTY',
  },
  {
    id: 15,
    name: TransactionTypeEnum.REDEMPTION,
    type: 'REDEMPTION',
    code: 'RDM',
  },
  {
    id: 16,
    name: TransactionTypeEnum.TRANSFER_IN,
    type: 'TRANSFER_IN',
    code: 'TRNI',
  },
  {
    id: 17,
    name: TransactionTypeEnum.TRANSFER_OUT,
    type: 'TRANSFER_OUT',
    code: 'TRNO',
  },
  {
    id: 18,
    name: TransactionTypeEnum.CALL_REDEMPTION,
    type: 'CALL_REDEMPTION',
    code: 'CRDM',
  },
  {
    id: 19,
    name: TransactionTypeEnum.PUT_REDEMPTION,
    type: 'PUT_REDEMPTION',
    code: 'PRDM',
  },
  {
    id: 20,
    name: TransactionTypeEnum.OTHER_INCOME,
    type: 'OTHER_INCOME',
    code: 'INC',
  },
  {
    id: 21,
    name: TransactionTypeEnum.FX_TRADE,
    type: 'FX_TRADE',
    code: 'FXT',
  },
  {
    id: 22,
    name: TransactionTypeEnum.OTHER_EXPENSE,
    type: 'OTHER_EXPENSE',
    code: 'EXP',
  },
  {
    id: 25,
    name: TransactionTypeEnum.FX_SPOT_TRADE,
    type: 'FX_SPOT_TRADE',
    code: 'FXS',
  },
  {
    id: 26,
    name: TransactionTypeEnum.FX_FORWARD_TRADE,
    type: 'FX_FORWARD_TRADE',
    code: 'FXF',
  },
  {
    id: 27,
    name: TransactionTypeEnum.WRITE_DOWN,
    type: 'WRITE_DOWN',
    code: 'WD',
  },
  {
    id: 28,
    name: TransactionTypeEnum.CORPORATE_ACTION,
    type: 'CORPORATE_ACTION',
    code: 'CACT',
  },
  {
    id: 29,
    name: TransactionTypeEnum.EXCHANGE_IN,
    type: 'EXCHANGE_IN',
    code: 'EXIN',
  },
  {
    id: 30,
    name: TransactionTypeEnum.EXCHANGE_OUT,
    type: 'EXCHANGE_OUT',
    code: 'EXOT',
  },
  {
    id: 31,
    name: TransactionTypeEnum.CORPORATE_ACTION_SELL,
    type: 'CORPORATE_ACTION_SELL',
    code: 'CASL',
  },
  {
    id: 32,
    name: TransactionTypeEnum.INITIAL_LOAD,
    type: 'INITIAL_LOAD',
    code: 'LOAD',
  },
  {
    id: 33,
    name: TransactionTypeEnum.CAPITALIZATION_OF_INTEREST,
    type: 'CAPITALIZATION_OF_INTEREST',
    code: 'CAPI',
  },
  {
    id: 35,
    name: TransactionTypeEnum.EXPIRATION,
    type: 'EXPIRATION',
    code: 'EXPR',
  },
  {
    id: 36,
    name: TransactionTypeEnum.OPTION_SETTLE,
    type: 'OPTION_SETTLE',
    code: 'OPST',
  },
  {
    id: 37,
    name: TransactionTypeEnum.OPTION_WRITE,
    type: 'OPTION_WRITE',
    code: 'OWRI',
  },
  {
    id: 38,
    name: TransactionTypeEnum.BUY_COVER,
    type: 'BUY_COVER',
    code: 'BUYC',
  },
  {
    id: 39,
    name: TransactionTypeEnum.SHORT_SELL,
    type: 'SHORT_SELL',
    code: 'SHSL',
  },
  {
    id: 40,
    name: TransactionTypeEnum.MARGIN_VARIATION_IN,
    type: 'MARGIN_VARIATION_IN',
    code: 'MVI',
  },
  {
    id: 41,
    name: TransactionTypeEnum.MARGIN_VARIATION_OUT,
    type: 'MARGIN_VARIATION_OUT',
    code: 'MVO',
  },
  {
    id: 42,
    name: TransactionTypeEnum.FUTURE_SETTLE,
    type: 'FUTURE_SETTLE',
    code: 'FTST',
  },
  {
    id: 43,
    name: TransactionTypeEnum.RETURN_OF_CAPITAL,
    type: 'RETURN_OF_CAPITAL',
    code: 'RCAP',
  },
  {
    id: 44,
    name: TransactionTypeEnum.CAPITAL_GAIN_DISTRIBUTION,
    type: 'CAPITAL_GAIN_DISTRIBUTION',
    code: 'CAPD',
  },
  {
    id: 45,
    name: TransactionTypeEnum.CAPITAL_CONTRIBUTION,
    type: 'CAPITAL_CONTRIBUTION',
    code: 'CAPC',
  },
  {
    id: 46,
    name: TransactionTypeEnum.FOREIGN_TAX_WITHHELD,
    type: 'FOREIGN_TAX_WITHHELD',
    code: 'FTW',
  },
  {
    id: 47,
    name: TransactionTypeEnum.INITIAL_LOAD_OF_DEFERRED,
    type: 'INITIAL_LOAD_OF_DEFERRED',
    code: 'ILOD',
  },
  {
    id: 48,
    name: TransactionTypeEnum.CONTRIBUTION_WITHDRAWAL,
    type: 'CONTRIBUTION_WITHDRAWAL',
    code: 'CCW',
  },
  {
    id: 49,
    name: TransactionTypeEnum.CASH_FROM_CORPORATE_ACTION,
    type: 'CASH_FROM_CORPORATE_ACTION',
    code: 'CFCA',
  },
  {
    id: 50,
    name: TransactionTypeEnum.CASH_RECEIVABLE_ON_LOAD,
    type: 'CASH_RECEIVABLE_ON_LOAD',
    code: 'CROL',
  },
  {
    id: 51,
    name: TransactionTypeEnum.DIRECT_CASH_TRANSFER,
    type: 'DIRECT_CASH_TRANSFER',
    code: 'WIRE',
  },
  {
    id: 52,
    name: TransactionTypeEnum.STOCK_SPLIT,
    type: 'STOCK_SPLIT',
    code: 'SPLT',
  },
  {
    id: 53,
    name: TransactionTypeEnum.CURRENCY_FORWARD,
    type: 'CURRENCY_FORWARD',
    code: 'FWD',
  },
  {
    id: 56,
    name: TransactionTypeEnum.PRINCIPAL_REPAYMENT,
    type: 'PRINCIPAL_REPAYMENT',
    code: 'RPMT',
  },
  {
    id: 57,
    name: TransactionTypeEnum.OPTION_EXERCISE,
    type: 'OPTION_EXERCISE',
    code: 'OPEX',
  },
  {
    id: 58,
    name: TransactionTypeEnum.PREPAYMENT_ACCELERATION_PREMIUM,
    type: 'PREPAYMENT_ACCELERATION_PREMIUM',
    code: 'PPAP',
  },
  {
    id: 59,
    name: TransactionTypeEnum.MUTUAL_FUND_DIVIDEND,
    type: 'MUTUAL_FUND_DIVIDEND',
    code: 'MFD',
  },
  {
    id: 60,
    name: TransactionTypeEnum.FOREIGN_TAX_WITHHELD_REPAYMENT,
    type: 'FOREIGN_TAX_WITHHELD_REPAYMENT',
    code: 'FTWR',
  },
  {
    id: 61,
    name: TransactionTypeEnum.DRAW,
    type: 'DRAW',
    code: 'DRAW',
  },
  {
    id: 62,
    name: TransactionTypeEnum.PAYUP,
    type: 'PAYUP',
    code: 'PPU',
  },
  {
    id: 63,
    name: TransactionTypeEnum.CASH_BALANCE_FIELD_ADJUSTMENT,
    type: 'CASH_BALANCE_FIELD_ADJUSTMENT',
    code: 'CBFA',
  },
  {
    id: -1,
    name: TransactionTypeEnum.UNSUPPORTED,
    type: 'UNSUPPORTED',
    code: 'UNSUPPORTED',
  },
]

/** Placeholder transaction type used when the API returns an unsupported transaction type */
export const UnsupportedTransactionType = {
  id: -1,
  name: TransactionTypeEnum.UNSUPPORTED,
  type: 'UNSUPPORTED',
  code: 'UNSUPPORTED',
}

export const ENTRIES: TransactionTypeEnum[] = [
  TransactionTypeEnum.BUY,
  TransactionTypeEnum.TRANSFER_IN,
  TransactionTypeEnum.EXCHANGE_IN,
  TransactionTypeEnum.INITIAL_LOAD,
  TransactionTypeEnum.SHORT_SELL,
  TransactionTypeEnum.OPTION_WRITE,
  TransactionTypeEnum.OPTION_EXERCISE,
  TransactionTypeEnum.CURRENCY_FORWARD,
]

export const EXITS: TransactionTypeEnum[] = [
  TransactionTypeEnum.SELL,
  TransactionTypeEnum.TRANSFER_OUT,
  TransactionTypeEnum.EXCHANGE_OUT,
  TransactionTypeEnum.BUY_COVER,
  TransactionTypeEnum.EXPIRATION,
  TransactionTypeEnum.OPTION_SETTLE,
  TransactionTypeEnum.FUTURE_SETTLE,
  TransactionTypeEnum.MATURITY,
  TransactionTypeEnum.REDEMPTION,
  TransactionTypeEnum.CALL_REDEMPTION,
  TransactionTypeEnum.PUT_REDEMPTION,
  TransactionTypeEnum.CORPORATE_ACTION_SELL,
  TransactionTypeEnum.PRINCIPAL_REPAYMENT,
  TransactionTypeEnum.OPTION_EXERCISE,
  TransactionTypeEnum.CURRENCY_FORWARD,
]
